module.exports = __webpack_public_path__ + "static/media/guide_mobile_01.10793aa3.svg";